interface IValues {
  phoneNumber: string;
  password: string;
  isView: boolean;
}

export const validateLogin = (values: IValues) => {
  const errors: Partial<IValues> = {};
  if (!values.phoneNumber) {
    errors.phoneNumber = "Required";
  }
  if (!values.password) {
    errors.password = "Required";
  }
  return errors;
};
